import {ModuleWithProviders, NgModule, Directive} from '@angular/core';
import {DirectPayIpgComponent} from './direct-pay-ipg.component';
import {NgxLoadingModule, ngxLoadingAnimationTypes} from 'ngx-loading';
import {DirectPayIpgService} from "./direct-pay-ipg.service";

@NgModule({
  declarations: [
    DirectPayIpgComponent
  ],
  imports: [
    NgxLoadingModule.forRoot({
      fullScreenBackdrop:true,
      animationType: ngxLoadingAnimationTypes.doubleBounce,
      primaryColour: '#11256c',
      secondaryColour: '#5e5c5c',
      tertiaryColour: '#283661'
    })
  ],
  exports: [
    DirectPayIpgComponent
  ]
})

export class DirectPayIpgModule {
  public static forRoot(config): ModuleWithProviders<DirectPayIpgModule> {
    return {
      ngModule: DirectPayIpgModule,
      providers: [
        DirectPayIpgService,
        {provide: 'config', useValue: config}
      ],
    };
  }
}
